<template>
    <project-step-container
            cover-page
            :prev-name="newProject ? 'Cancel' : 'Exit'"
            prev-to="home"
            @next-click="saveProject()"
    >
        <b-row class="first-form">
            <b-col cols="12" class="mt-5 main-title" tabindex="0" role="heading">
                {{ newProject ? 'New Project' : 'Edit Project' }}
            </b-col>

            <b-col cols="12" class="mt-3">
                <label for="name">
                    {{getMessage(1 , 'project-name')}} </label> 
                    <!-- Project Name  -->
                <input aria-required="true" id="name" type="text"
                 :placeholder="getMessage(1, 'project-name-placeholder')"
                 v-model="form.name" value="" />
                <span v-if="nameError" class="form-error">This field is required</span>
            </b-col>

            <b-col cols="12" class="mt-3">
                <label for="problem">
                    {{getMessage(1 , 'project-problem')}}</label>
                <textarea aria-required="true" id="problem" type="text" v-model="form.problem"           
                          aria-label="What problem are you trying to solve?  Remember, this problem can change as you learn more. "
                          :placeholder="getMessage(1, 'project-problem-placeholder')"
                      ></textarea>
                <span v-if="problemError" class="form-error">This field is required</span>
            </b-col>

            <b-col cols="12" class="mt-3">
                <label for="customer">{{getMessage(1 , 'project-customer')}}
                    </label>
                <input aria-required="true" id="customer" type="text" v-model="form.customer" value=""
                       :placeholder="getMessage(1, 'project-customer-placeholder')"
                  />
                <span v-if="customerError" class="form-error">This field is required</span>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12">
                <LinkStyleGuide @open-url="openGuide" icon-name="icon-guide"
                                text="Customer Driven Innovation Guide"/>
            </b-col>
        </b-row>
         <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import {Storage, Project , StyleGuides} from '../../../core/Utils'
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"

    export default {
        name: "CreateProject",
        props: ['newProject'],
        components: {ProjectStepContainer , LinkStyleGuide, ProjectStyleGuide},
        data() {
            return {
                form: {
                    name: "",
                    problem: "",
                    customer: ""
                },
                projectId: null,
                nameError: false,
                problemError: false,
                customerError: false , 
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.CUSTOMER_DRIVE_INNOVATION_GUIDE),
            }
        },
        mounted() {
            if (!this.newProject) {
                const index = this.$route.params.index
                const projectData = Storage.getProject(index)
                this.form.name = projectData['name']
                this.form.problem = projectData['problem']
                this.form.customer = projectData['customer']
            }
        },
        methods: {
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            saveProject: function () {
                this.nameError = this.form.name === ""
                this.problemError = this.form.problem === ""
                this.customerError = this.form.customer === ""
                if (this.nameError || this.problemError || this.customerError) return

                const index = this.$route.params.index

                Project.saveProject(this.newProject, index, Project.PROJECT_D4D, this.form.name, this.form.problem,
                    this.form.customer, this.isOffline
                ).then(response => {
                    this.$router.push({name: 'deep_customer_empathy_2', params: {index: response.index}})
                }).catch(err => {
                    this.$router.push({name: 'home'})
                })
            }
        }
    }
</script>

<style scoped lang="stylus">
    @import "../Styles/d4d_styles.styl"

    .high-contrast
        .document-link
            color black

    .first-form
        padding-bottom 40px
        border-radius 0 0 27px 27px
        box-shadow(0px 4px 5px 0px color-19)
        background-color white
        z-index: 3;
        position relative

    .second-form
        position relative
        top -19px
        padding-bottom 16px
        border-radius 0 0 27px 27px
        background-color white
        box-shadow(0px 4px 5px 0px #BDD5E580)

    .sub-title
        font font-poppins-semibold
        font-size 11px
        color color-22

    .main-title
        font font-poppins-semibold
        font-size 21px
        color black

    .document-link
        font font-sourcesans-semibold
        font-size 16px
        text-decoration underline
        display inline-block
        color color-4
        max-width 225px
        margin-left 15px
        margin-top 10px
        vertical-align bottom

</style>